import * as React from 'react';

export enum ChartMode {
	showAll = 'showAll',
	hideAll = 'hideAll',
	erpImpact = 'erpImpact',
}

interface ChartModeCheckboxesProps {
	chartMode: null | string;
	onChartModeSet: (type: string) => void;
}

export function ChartModeCheckboxes({ chartMode, onChartModeSet }: ChartModeCheckboxesProps) {
	return (
		<div className='absolute top-24 left-4 w-full'>
			<label
				className='relative inline-block mr-6 pl-5 h-5 text-md leading-5 cursor-pointer'
				onClick={() => onChartModeSet(ChartMode.showAll)}
			>
				Show All
				<input
					checked={chartMode === ChartMode.showAll}
					type='radio'
					className='absolute left-0 top-0.5 w-4 h-4 pointer-events-none'
					onChange={(e) => e.preventDefault()}
				/>
			</label>
			<label
				className='relative inline-block mr-6 pl-5 h-5 text-md leading-5 cursor-pointer'
				onClick={() => onChartModeSet(ChartMode.hideAll)}
			>
				Hide All
				<input
					checked={chartMode === ChartMode.hideAll}
					type='radio'
					className='absolute left-0 top-0.5 w-4 h-4 pointer-events-none'
					onChange={(e) => e.preventDefault()}
				/>
			</label>
			<label
				className='relative inline-block mr-6 pl-5 h-5 text-md leading-5 cursor-pointer'
				onClick={() => onChartModeSet(ChartMode.erpImpact)}
			>
				IRP Impact
				<input
					checked={chartMode === ChartMode.erpImpact}
					type='radio'
					className='absolute left-0 top-0.5 w-4 h-4 pointer-events-none'
					onChange={(e) => e.preventDefault()}
				/>
			</label>
		</div>
	);
}
